import { RouterModule, Routes } from '@angular/router';
//import { LoginRGuardGuard } from './services/service.index'
import { PagesComponent } from './pages/pages.component';
import { AuthRedirectGuard } from './services/guards/redirect.guard';
import { LoginComponent } from './login/login.component';
import { LoginBaseComponent } from './loginbase/loginbase.component';
import { LoginVentusComponent } from './loginventus/loginventus.component';
import { LoginFliebenCapComponent } from './loginfliebencap/loginfliebencap.component';
import { LoginFliebenTresComponent } from './loginfliebentres/loginfliebentres.component';
import { LoginFacteaComponent } from './loginfactea/loginfactea.component';
import { LoginUnitaComponent } from './loginunita/loginunita.component';
import { LoginUnitaGuard } from './services/guards/loginunita.guard';
import { LoginFacturacionComponent } from './loginfacturacion/loginfacturacion.component';
import { LoginFacturacionGuard } from './services/guards/loginfacturacion.guard';
import { ResetpwdComponent } from './login/resetpwd.component';
import { ResetpwdBaseComponent } from './loginbase/resetpwdbase.component';
import { NopagefoundComponent } from './shared/nopagefound/nopagefound.component';
import { AccesoDenegadoComponent } from './shared/accesodenegado/accesodenegado.component';


const appRoutes: Routes = [
    { path: 'login', component: LoginComponent, canActivate: [AuthRedirectGuard]},
    { path: 'loginbase', component: LoginBaseComponent, canActivate: [AuthRedirectGuard]},
    { path: 'loginven', component: LoginVentusComponent, canActivate: [AuthRedirectGuard] },
    { path: 'loginfbcap', component: LoginFliebenCapComponent, canActivate: [AuthRedirectGuard]},
    { path: 'loginfbtres', component: LoginFliebenTresComponent, canActivate: [AuthRedirectGuard] },
    { path: 'loginfactea', component: LoginFacteaComponent, canActivate: [AuthRedirectGuard] },
    { path: 'loginunita', component: LoginUnitaComponent, canActivate: [LoginUnitaGuard] },
    { path: 'loginfacturacion', component: LoginFacturacionComponent, canActivate: [LoginFacturacionGuard] },
    { path: 'resetpwd/:token', component: ResetpwdComponent },
    { path: 'resetpwdbase/:token', component: ResetpwdBaseComponent },
    { path: 'accesodenegado', component: AccesoDenegadoComponent },
    { path: '**', component: NopagefoundComponent }
];


export const APP_ROUTES = RouterModule.forRoot( appRoutes, { useHash: true } );
